<div class="sidebar-outer">
  @if (settings.theme.sidebarIsFixed) {
    <a
      class="logo d-flex align-items-center"
      routerLink="/"
      (click)="closeSubMenus()"
    >
      <img src="assets/img/logos/header-logo.long.png" />
    </a>
  }
  <app-vertical-menu [menuItems]="menuItems"></app-vertical-menu>
</div>
